import axios from "axios";

axios.defaults.withCredentials = true;

const httpClient = axios.create();
// timeout à 60 seconde
httpClient.defaults.timeout = 60000;

export default {
  /**
   * Récupére les demandes winpaie par lot
   */
  async getDemandesWPRHByLot(id) {
    const demandes = await httpClient.get(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_WPRH + id
    );
    return demandes.data;
  },

  exportWPRH(id) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      process.env.VUE_APP_URL_FILE +
      process.env.VUE_APP_URL_WPRH_EXCEL_ZIP +
      id
    );
  },
};
